import { SaveAccountBrandingRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

export default function useUpdateAccountBranding() {
  const api = useApi();

  async function updateAccountBranding(params: SaveAccountBrandingRequest) {
    try {
      const res = await api.postAccountBranding(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return {
    updateAccountBranding,
  };
}
